




















































































































import Vue from "vue";

import BadgeDrillListening from "@joyz/app-core/assets/badge/DrillListening.svg";
import BadgeDrillPronunciation from "@joyz/app-core/assets/badge/DrillPronunciation.svg";
import BadgeDrillVocabulary from "@joyz/app-core/assets/badge/DrillVocabulary.svg";
import GifBronze from "@joyz/app-core/assets/trophy/skills/ThumbsUp.gif";
import GifSilver from "@joyz/app-core/assets/trophy/skills/Clap.gif";
import GifGold from "@joyz/app-core/assets/trophy/skills/Star.gif";
import IconIncorrect from "@joyz/app-core/assets/icons/Incorrect.svg";
import IconCorrect from "@joyz/app-core/assets/icons/Correct.svg";
import IconSkip from "@joyz/app-core/assets/icons/misc/DrillSkip.svg";

import { DrillState, TrophyState, ExerciseType } from "@tt-app/models/exercise";
import { EXERCISE_TYPE } from "@tt-app/constants";

interface Data {
  icons: { [key: string]: string };
}

interface Computed {
  trophyEffectiveUrl: string;
}

interface Props {
  drill: DrillState;
  exerciseType: ExerciseType;
  selectedGrade: number;
  totalWords: number;
  trophy: TrophyState;
}

export default Vue.extend<Data, {}, Computed, Props>({
  name: "PracticeVocabularyDrillTrophy",
  components: {},

  props: {
    drill: { type: Object as () => DrillState, required: true },
    exerciseType: { type: Number as () => ExerciseType, required: true },
    selectedGrade: { type: Number, default: undefined },
    totalWords: { type: Number, default: 0 },
    trophy: { type: Object as () => TrophyState, required: true }
  },

  data() {
    let badge = "";
    switch (this.exerciseType) {
      case EXERCISE_TYPE.DRILL_VOCABULARY:
        badge = BadgeDrillVocabulary;
        break;
      case EXERCISE_TYPE.DRILL_PRONUNCIATION:
        badge = BadgeDrillPronunciation;
        break;
      case EXERCISE_TYPE.DRILL_LISTENING:
        badge = BadgeDrillListening;
        break;
    }

    return {
      icons: {
        badge,
        correct: IconCorrect,
        incorrect: IconIncorrect,
        skip: IconSkip
      }
    };
  },

  computed: {
    trophyEffectiveUrl(): string {
      if (this.trophy.imgUrl) {
        return this.trophy.imgUrl;
      }

      switch (this.trophy.score) {
        case 1:
          return GifBronze;
        case 2:
          return GifSilver;
        case 3:
          return GifGold;
        default:
          throw new Error(`ChatTrophy must have either a TrophyImgUrl or a TrophyScore`);
      }
    }
  },

  methods: {}
});
